export enum ResponseStatus {
  Error = 'error',
  Success = 'success',
}
